import { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../useLanguage';

const PrivacyPage = () => {
  const { t } = useLanguage();
  const [emailRevealed, setEmailRevealed] = useState('');
  const emailLinkRef = useRef<HTMLAnchorElement>(null);

  const revealEmail = () => {
    const scrambled = 'moc.liamg@izerauj.nimajneb';
    const email = scrambled.split('').reverse().join('');
    setEmailRevealed(email);
  };

  useEffect(() => {
    if (emailRevealed) emailLinkRef.current?.focus();
  }, [emailRevealed]);

  const sections = [
    { title: t.privacy.overviewTitle, body: t.privacy.overviewBody },
    { title: t.privacy.dataCollectedTitle, body: t.privacy.dataCollectedBody },
    { title: t.privacy.purchasesTitle, body: t.privacy.purchasesBody },
    { title: t.privacy.thirdPartiesTitle, body: t.privacy.thirdPartiesBody },
    { title: t.privacy.trackingTitle, body: t.privacy.trackingBody },
    { title: t.privacy.retentionTitle, body: t.privacy.retentionBody },
    { title: t.privacy.childrenTitle, body: t.privacy.childrenBody },
    { title: t.privacy.changesTitle, body: t.privacy.changesBody },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-dark-900">
      <Header activeSection="" />
      <main id="main-content" tabIndex={-1} className="pt-16">
        <section className="section-padding bg-white dark:bg-dark-900">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                {t.privacy.title}
              </h1>
              <p className="text-lg text-gray-600 dark:text-gray-300">{t.privacy.subtitle}</p>
              <p className="mt-4 text-sm font-medium text-gray-500 dark:text-gray-400">
                {t.privacy.effectiveDate}
              </p>
            </div>

            <div className="space-y-8">
              {sections.map((section) => (
                <section key={section.title}>
                  <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {section.title}
                  </h2>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{section.body}</p>
                </section>
              ))}

              <section>
                <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                  {t.privacy.contactTitle}
                </h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                  {t.privacy.contactBody}
                </p>
                <div className="flex items-center space-x-4" aria-live="polite">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-xl font-bold text-primary-600 dark:text-primary-400">@</span>
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-medium text-gray-900 dark:text-white">{t.games.email}</h3>
                    {emailRevealed ? (
                      <a
                        ref={emailLinkRef}
                        href={`mailto:${emailRevealed}`}
                        className="min-h-11 inline-flex items-center break-all text-secondary-700 dark:text-secondary-300 hover:underline"
                      >
                        {emailRevealed}
                      </a>
                    ) : (
                      <button
                        onClick={revealEmail}
                        className="min-h-11 inline-flex items-center text-secondary-700 dark:text-secondary-300 hover:underline"
                      >
                        {t.games.clickToReveal}
                      </button>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;